import { render, staticRenderFns } from "./DXC.vue?vue&type=template&id=382d4da6&"
import script from "./DXC.vue?vue&type=script&lang=js&"
export * from "./DXC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports